/*
depot_icon_url: 'data:image/svg+xml;base64,<svg width="48" height="62" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g transform="translate(0 .667)"><path fill="#D8D8D8" d="M24 61.333l16-26.666H8z"/><circle fill="#EF493C" cx="24" cy="24" r="24"/></g><path fill="#FFF" d="M24 11.333l-13.333 12.6v2.084h2.347v9.316h4.057v-9.316h13.858v9.316h4.057v-9.316h2.347v-2.084z"/></g></svg>',
  event_icon_url: 'data:image/svg+xml;base64,<svg width="48" height="62" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g transform="translate(0 .667)"><path fill="#D8D8D8" d="M24 61.333l16-26.666H8z"/><circle fill="#EF493C" cx="24" cy="24" r="24"/></g><path d="M30.24 15.26c-1.556 0-2.987-.733-4.112-1.956h-.009c-1.125-1.218-2.55-1.947-4.104-1.947-1.552 0-2.979.729-4.104 1.947h-.009v13.69c1.127-1.222 2.557-1.954 4.113-1.954 1.556 0 2.986.732 4.113 1.955h.009c1.124 1.218 2.55 1.948 4.102 1.948 1.554 0 2.98-.73 4.104-1.948h.01V13.304c-1.128 1.223-2.558 1.956-4.114 1.956zm-15.516-3.926c-.745 0-1.35.647-1.35 1.446v24.11h2.701V12.78c0-.799-.604-1.446-1.35-1.446z" fill="#FFF"/></g></svg>',
*/

var LOCATOR = {
  map: null,
  geocoder: null,
  geolocation: {
    lat: 62.24,
    lng: -96.28
  },
  province: false,
  origin_icon_url: '/wp-content/themes/product-care-recycling/dist/images/icon-map-marker.svg',
  depot_icon_url: '/wp-content/themes/product-care-recycling/dist/images/marker-depot.svg',
  retail_icon_url: '/wp-content/themes/product-care-recycling/dist/images/marker-retail.svg',
  event_icon_url: '/wp-content/themes/product-care-recycling/dist/images/marker-event.svg',
  close_icon_url: '/wp-content/themes/product-care-recycling/dist/images/infobox-close.svg',
  origin_marker: null,
  range: 3,
  bounds: null,
  filtered_collection_sites: [],
  markers: [],
  marker_clusterer: false,
  current_infobox: false,
  location_search_input: document.getElementById('location-search'),
  location_search: null,
  product_search_input: document.getElementById('product-search'),
  product_search_index: null,
  product_select: document.getElementById('product-select'),
  product: false,
  styles: [{"featureType":"landscape","elementType":"all","stylers":[{"hue":"#FFBB00"},{"saturation":43.400000000000006},{"lightness":37.599999999999994},{"gamma":1}]},{"featureType":"poi","elementType":"all","stylers":[{"hue":"#00FF6A"},{"saturation":-1.0989010989011234},{"lightness":11.200000000000017},{"gamma":1}]},{"featureType":"road.highway","elementType":"all","stylers":[{"hue":"#FFC200"},{"saturation":-61.8},{"lightness":45.599999999999994},{"gamma":1}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"hue":"#FF0300"},{"saturation":-100},{"lightness":51.19999999999999},{"gamma":1}]},{"featureType":"road.local","elementType":"all","stylers":[{"hue":"#FF0300"},{"saturation":-100},{"lightness":52},{"gamma":1}]},{"featureType":"water","elementType":"all","stylers":[{"hue":"#0078FF"},{"saturation":-13.200000000000003},{"lightness":2.4000000000000057},{"gamma":1}]}],
  window_width: window.innerWidth,
  window_height: window.innerHeight,
  is_tablet: false,
  is_mobile: false,

  init: function() {
    this.windowResize();
    window.onresize = this.windowResize;
    this.windowScroll();
    window.onscroll = this.windowScroll;

    jQuery('a.filter-toggle').click(function(e) {
      e.preventDefault();
      jQuery(this).parent().toggleClass('open');
    });

    jQuery('.recycfluo-overlay .close, .recycfluo-overlay .button').click(function(e) {
      e.preventDefault();

      jQuery('.recycfluo-overlay').addClass('hiding').fadeOut();
    });

    this.initForm();
    this.loadInfobox();
    this.initMap();
    this.initLocationSearch();
    //this.initProductSearch();
    this.initProductSelect();
  },

  loadInfobox: function() {
    setTimeout(function() {
      var infobox_script = document.createElement('script');
      infobox_script.type = "text/javascript";
      infobox_script.src = "/wp-content/themes/product-care-recycling/dist/scripts/infobox.js";
      infobox_script.onload = function() {
        LOCATOR.initGeocoder();
      };
      document.body.appendChild(infobox_script);
    }, 1000);
  },

  initMap: function() {
    var zoom_control = true;
    if(this.is_tablet || this.is_mobile) {
      zoom_control = false;
    }

    this.map = new google.maps.Map(document.getElementById('map'), {
      zoom: 14,
      center: this.geolocation,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false,
      disableDefaultUI: true,
      zoomControl: zoom_control,
      styles: this.styles
    });
  },
  mapSetCenter: function() {
    LOCATOR.map.setCenter(LOCATOR.geolocation);
  },
  mapFilterCollectionSites: function() {
    this.filtered_collection_sites = [];

    for(var i = 0; i < collection_sites.length; i++) {
      var c = collection_sites[i];
      c.distance = LOCATOR.distHaversine(this.geolocation, c.geolocation);

      if(LOCATOR.province) {
        if(LOCATOR.province === c.address.province.value) {
          if(LOCATOR.product) {
            if(c.accepted_products && c.accepted_products.indexOf(LOCATOR.product) !== -1) {
              this.filtered_collection_sites.push(c);
            }
          } else {
            this.filtered_collection_sites.push(c);
          }
        }
      } else {
        if(LOCATOR.product) {
          if(c.accepted_products && c.accepted_products.indexOf(LOCATOR.product) !== -1) {
            this.filtered_collection_sites.push(c);
          }
        } else {
          this.filtered_collection_sites.push(c);
        }
      }
    }

    this.mapClearMarkers();
    if(this.filtered_collection_sites.length > 0) {
      this.filtered_collection_sites.sort(function(a, b) {
        return parseFloat(a.distance)-parseFloat(b.distance);
      });
      this.mapSetMarkers();
    } else {
      this.handleError('no results');
    }
  },
  mapClearMarkers: function() {
    jQuery('#results .result-item').remove();
    jQuery('#results').html('');

    for(var i = 0; i < LOCATOR.markers.length; i++) {
      LOCATOR.markers[i].setMap(null);
    }
    LOCATOR.markers = [];

    if(LOCATOR.marker_clusterer) {
      LOCATOR.marker_clusterer.clearMarkers();
    }
  },
  mapSetMarkers: function() {
    LOCATOR.bounds = new google.maps.LatLngBounds();
    LOCATOR.bounds.extend(LOCATOR.geolocation);

    var extended = false;
    for(var i = 0; i < LOCATOR.filtered_collection_sites.length; i++) {
      var c = LOCATOR.filtered_collection_sites[i],
          icon_url = LOCATOR.depot_icon_url;

      if(c.type === 'event') {
        icon_url =LOCATOR.event_icon_url;
      } else if(c.type === 'retail') {
        icon_url =LOCATOR.retail_icon_url;
      }

      var marker = new google.maps.Marker({
            position: c.geolocation,
            map: LOCATOR.map,
            title: c.title,
            icon: {
              size: new google.maps.Size(48, 62),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(24, 62),
              url: icon_url,
              scaledSize: new google.maps.Size(48, 62),
            },
            optimized: false,
          }),
          result_item = jQuery(LOCATOR.getResultItem(c)),
          infobox_content = LOCATOR.getInfoboxContent(c),
          infobox = new InfoBox({
            content: infobox_content,
            maxWidth: 332,
            pixelOffset: new google.maps.Size(-24, -12),
            zIndex: null,
            closeBoxMargin: '4px',
            closeBoxURL: LOCATOR.close_icon_url,
            infoBoxClearance: new google.maps.Size(10, 66),
            visible: true,
            enableEventPropagation: false,
            alignBottom: true
          });

      LOCATOR.markers.push(LOCATOR.mapConnectMarker(marker, infobox, result_item));

      if(c.distance <= LOCATOR.range) {
        LOCATOR.bounds.extend(c.geolocation);
        extended = true;
      }
      jQuery('#results').append(result_item);
    }

    jQuery('#results').append('<div class="drag-instructions">'+t_drag+'</div>');

    if(!extended && LOCATOR.filtered_collection_sites.length>0) {
      LOCATOR.bounds.extend(LOCATOR.filtered_collection_sites[0].geolocation);
    }

    LOCATOR.marker_clusterer = new MarkerClusterer(LOCATOR.map, LOCATOR.markers, {
      styles: [{
        url: '/wp-content/themes/product-care-recycling/dist/images/m.png',
        height: 52,
        width: 52,
        anchor: [52, 52],
        textColor: '#ffffff',
        textSize: 12
      }]
    });

    if(!LOCATOR.is_tablet && !LOCATOR.is_mobile) {
      LOCATOR.map.fitBounds(LOCATOR.bounds, 200);
    } else {
      LOCATOR.map.fitBounds(LOCATOR.bounds);
    }
  },
  mapConnectMarker: function(marker, infobox, result_item) {
    google.maps.event.addListener(marker, 'click', openInfowindow);
    result_item.click(openInfowindow);

    toggleResults();
    google.maps.event.addListener(LOCATOR.map, 'bounds_changed', toggleResults);

    result_item.find('.accepted-products li').click(function(e) {
      e.preventDefault();

      result_item.find('.accepted-products li.hover').removeClass('hover');
      //jQuery(this).toggleClass('hover');
    });

    result_item.find('.more-info-toggle').click(function(e) {
      e.preventDefault();

      if(result_item.hasClass('open')) {
        result_item.removeClass('open');
      } else {
        result_item.addClass('open');
      }
    });

    function openInfowindow() {
      jQuery('#results .result-item.active').removeClass('active');
      result_item.addClass('active');
      jQuery('#results').animate({ scrollTop:(result_item.position().top+jQuery('#results').scrollTop()-144) });

      if(LOCATOR.current_infobox) LOCATOR.current_infobox.close();

      if(LOCATOR.is_tablet || LOCATOR.is_mobile) {
        var adjustment = jQuery('.result-item.active .more-info').outerHeight();
        if(LOCATOR.is_mobile) {
          adjustment = jQuery('.result-item.active').outerHeight() - jQuery('.result-item.active .heading').outerHeight();
        }

        jQuery('#results').css({ transform:'translate3d(0,'+adjustment+'px,0)' });
        //TweenLite.set('#results', { clearProps: 'transform' });

        jQuery('#results .drag-instructions').addClass('visible');
        setTimeout(function() {
          jQuery('#results .drag-instructions').addClass('disable');
        }, 5000);

        Draggable.create('#results', {
          type:"y",
          edgeResistance:0.65,
          bounds:".collection-sites-wrapper",
          throwProps:true,
          bounds:{minY:0, maxY:adjustment},
          maxDuration:0.2,
          allowNativeTouchScrolling:false,
          snap: {
            y: function(endValue) {
              return Math.round(endValue / adjustment) * adjustment;
            }
          },
          onDragStart: function() {
            jQuery('#results .drag-instructions').addClass('disable');
          }
        });

        TweenLite.to(window, 1, { scrollTo:'.collection-sites-header' });

        LOCATOR.map.panTo(marker.getPosition());
        LOCATOR.map.setZoom(17);

        var map_height = jQuery('#map').height();
        LOCATOR.map.panBy(0,(map_height/2)-100);
      } else {
        infobox.open(LOCATOR.map, marker);
        LOCATOR.current_infobox = infobox;
        //LOCATOR.map.panTo(marker.getPosition());
      }

    }
    function toggleResults() {
      if(LOCATOR.map.getBounds().contains(marker.getPosition())) {
        result_item.css({ display:'block' });
      } else {
        result_item.css({ display:'none' });
      }
    }

    return marker;
  },
  getResultItem: function(c) {
    var result_item = '<div class="result-item">';
    result_item += '<div class="chip">';

    if(c.type === 'event') {
      result_item += '<span class="icon small icon-event">'+icon_event+'</span>'+t_event+'<span class="event-date"> | '+c.event.display_date+'</span>';
    } else if(c.type === 'retail') {
      result_item += '<span class="icon small icon-depot">'+icon_retail+'</span>'+t_retail;
    } else {
      result_item += '<span class="icon small icon-retail">'+icon_depot+'</span>'+t_depot;
    }

    result_item += '</div>';
    result_item += '<div class="heading">';
    result_item += '<h5>'+c.title+'</h5>';

    result_item += '<h6>';
    result_item += c.address.address_line_1;
    if(c.address.address_line_2) {
      result_item += ', '+c.address.address_line_2;
    }
    if(c.address.city) {
      result_item += ', '+c.address.city;
    }
    if(c.address.province) {
      result_item += ', '+c.address.province.value.toUpperCase();
    }
    if(c.address.postal_code) {
      result_item += ', '+c.address.postal_code;
    }
    result_item += '</h6>';

    var distance = parseFloat(c.distance);
    if(distance >= 20) {
      distance = distance.toFixed(0);
    } else if(distance >= 10) {
      distance = distance.toFixed(1);
    }

    result_item += '<span class="distance h5">'+distance.toString()+'km</span>';

    result_item += '</div>';
    result_item += '<div class="info">';
    result_item += '<h5>'+t_accepted_products+'</h5>';
    result_item += '<p>'+t_accepted_products_note+'</p>';
    result_item += '<ul class="accepted-products clearfix">';

    if(c.accepted_products) {
      if(c.accepted_products.indexOf('paint') !== -1) {
        result_item += '<li class="icon icon-paint">'+icon_paint;
        result_item += '<span class="tooltip"><span>'+t_paint+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('paint-cans') !== -1) {
        result_item += '<li class="icon icon-paint">'+icon_paint;
        result_item += '<span class="tooltip"><span>'+t_paint_cans+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('paint-aerosol') !== -1) {
        result_item += '<li class="icon icon-paint-aerosol">'+icon_paint_aerosol;
        result_item += '<span class="tooltip"><span>'+t_paint_aerosol+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('paintshare') !== -1) {
        result_item += '<li class="icon icon-paintshare">'+icon_paintshare;
        result_item += '<span class="tooltip"><span>'+t_paintshare+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('hhw') !== -1) {
        result_item += '<li class="icon icon-hhw">'+icon_hhw;
        result_item += '<span class="tooltip"><span>'+t_hhw+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('hsp') !== -1) {
        result_item += '<li class="icon icon-hhw">'+icon_hhw;
        result_item += '<span class="tooltip"><span>'+t_hsp+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('non-refillable-pressurized-cylinders') !== -1) {
        result_item += '<li class="icon icon-hhw">'+icon_non_refillable_pressurized_cylinders;
        result_item += '<span class="tooltip"><span>'+t_non_refillable_pressurized_cylinders+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('refillable-propane-cylinders') !== -1) {
        result_item += '<li class="icon icon-hhw">'+icon_refillable_propane_cylinders;
        result_item += '<span class="tooltip"><span>'+t_refillable_propane_cylinders+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('ontario-lights') !== -1) {
        result_item += '<li class="icon icon-lights">'+icon_lights;
        result_item += '<span class="tooltip"><span>'+t_ontario_lights+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('lights') !== -1) {
        result_item += '<li class="icon icon-lights">'+icon_lights;
        result_item += '<span class="tooltip"><span>'+t_lights+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('commercial-lights') !== -1) {
        result_item += '<li class="icon icon-commercial-lights">'+icon_commercial_lights;
        result_item += '<span class="tooltip"><span>'+t_commercial_lights+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('residential-fixtures') !== -1) {
        result_item += '<li class="icon icon-residential-fixtures">'+icon_residential_fixtures;
        result_item += '<span class="tooltip"><span>'+t_residential_fixtures+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('commercial-fixtures') !== -1) {
        result_item += '<li class="icon icon-commercial-fixtures">'+icon_commercial_fixtures;
        result_item += '<span class="tooltip"><span>'+t_commercial_fixtures+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('ballasts') !== -1) {
        result_item += '<li class="icon icon-ballasts">'+icon_ballasts;
        result_item += '<span class="tooltip"><span>'+t_ballasts+'</span></span></li>';
      }
      if(c.accepted_products.indexOf('alarms') !== -1) {
        result_item += '<li class="icon icon-alarms">'+icon_alarms;
        result_item += '<span class="tooltip"><span>'+t_alarms+'</span></span></li>';
      }
    }

    result_item += '</ul>';

    var directions_url = 'https://www.google.com/maps/dir/?api=1&destination='+c.geolocation.lat+','+c.geolocation.lng;

    if(c.contact.website) {
      result_item += '<a class="button" href="'+directions_url+'" target="_blank">'+t_get_directions+'</a>';
      result_item += '<a class="button" href="'+c.contact.website+'" target="_blank">'+t_website+'</a>';
    } else {
      result_item += '<a class="button full-width" href="'+directions_url+'" target="_blank">'+t_get_directions+'</a>';
    }

    result_item += '</div>';

    result_item += '<ul class="more-info">';

    /*result_item += '<li><span class="icon icon-map-marker">'+icon_map_marker+'</span>';
    result_item += c.address.address_line_1;
    if(c.address.address_line_2) {
      result_item += ', '+c.address.address_line_2;
    }
    if(c.address.city) {
      result_item += ', '+c.address.city;
    }
    if(c.address.province) {
      result_item += ', '+c.address.province.value.toUpperCase();
    }
    if(c.address.postal_code) {
      result_item += ', '+c.address.postal_code;
    }
    result_item += '</li>';*/

    if(c.hours) {
      result_item += '<li><span class="icon icon-time">'+icon_time+'</span>'+c.hours+'</li>';
    }

    if(c.contact.phone) {
      result_item += '<li><span class="icon icon-telephone">'+icon_telephone+'</span><a href="tel:'+c.contact.phone+'" target="_blank">'+c.contact.phone+'</a></li>';
    }

    if(c.contact.email) {
      result_item += '<li><span class="icon icon-email">'+icon_email+'</span><a href="mailto:'+c.contact.email+'" target="_blank">'+c.contact.email+'</a></li>';
    }

    if(c.notes) {
      result_item += '<li><span class="icon icon-edit">'+icon_edit+'</span>'+c.notes+'</li>';
    }
    result_item += '</ul>';

    result_item += '<a class="more-info-toggle" href="'+c.permalink+'"><span class="icon icon-arrow-down left">'+icon_arrow_down+'</span><span class="more">'+t_more_details+'</span><span class="less">'+t_less_details+'</span><span class="icon icon-arrow-down right">'+icon_arrow_down+'</span></a>';

    result_item += '</div>';

    return result_item;
  },
  getInfoboxContent: function(c) {
    var infobox_content = '<div class="infobox">';
    if(c.type === 'event') {
      infobox_content += '<span class="icon large icon-event">'+icon_event+'</span>';
    } else if(c.type === 'retail') {
      infobox_content += '<span class="icon large icon-retail">'+icon_retail+'</span>';
    } else {
      infobox_content += '<span class="icon large icon-depot">'+icon_depot+'</span>';
    }
    //infobox_content += '<a class="close" href="#">'+icon_close+'</a>';
    infobox_content += '<h5>'+c.title+'</h5>';
    infobox_content += '<p>'+t_see_sidebar+'</p>';
    infobox_content += '</div>';

    return infobox_content;
  },

  initLocationSearch: function() {
    this.location_search = new google.maps.places.Autocomplete(this.location_search_input, {
      types: ['geocode'],
      componentRestrictions: {'country': ['ca']}
    });

    google.maps.event.addDomListener(this.location_search_input, 'keydown', function(e) {
      if(e.keyCode === 13) {
        e.preventDefault();

        if(this.value === '') {
          LOCATOR.geolocate();
        }
      }
    });

    this.location_search.addListener('place_changed', this.locationPlaceChanged);
  },
  locationPlaceChanged: function() {
    var place = this.getPlace();

    if(place.geometry) {
      LOCATOR.setGeolocation(place.geometry.location.lat(), place.geometry.location.lng());
      LOCATOR.setProvince(LOCATOR.getProvinceFromResults(place));
    }
  },

  initProductSearch: function() {
    this.product_search_input.addEventListener('input', this.productSearchInput);
    this.product_search_input.addEventListener('keydown', this.productSearchKeydown);

    document.addEventListener('click', function(e) {
      LOCATOR.productSearchCloseList(e.target);
    });
  },
  productSearchInput: function() {
    var pac_container, pac_item, i, val = this.value;

    LOCATOR.productSearchCloseList();

    if(!val) {
      return false;
    }
    LOCATOR.product_search_index = -1;

    pac_container = document.createElement('div');
    pac_container.setAttribute('id', 'product-list');
    pac_container.setAttribute('class', 'pac-container');
    this.parentNode.appendChild(pac_container);

    for(i = 0; i < search_terms.length; i++) {
      var term = search_terms[i].term,
          product = search_terms[i].product;
          search_index = term.toUpperCase().indexOf(val.toUpperCase());

      if(search_index !== -1) {
        pac_item = document.createElement('div');
        pac_item.setAttribute('class', 'pac-item');

        pac_item.innerHTML = '<span class="pac-item-query">' + term.substr(0, search_index) + '<span class="pac-matched">' + term.substr(search_index, val.length) + '</span>' + term.substr(search_index + val.length) + '</span><span>' + product.label + '</span>';
        pac_item.innerHTML += '<input type="hidden" value="' + term + '" />';
        pac_item.innerHTML += '<input type="hidden" value="' + product.value + '" />';

        pac_item.addEventListener('click', function(e) {
          LOCATOR.product_search_input.value = this.getElementsByTagName('input')[0].value;
          LOCATOR.product = this.getElementsByTagName('input')[1].value;
          
          LOCATOR.productChanged();
          LOCATOR.productSearchCloseList();
        });

        if(search_index === 0) {
          pac_container.insertBefore(pac_item, pac_container.firstChild);
        } else {
          pac_container.appendChild(pac_item);
        }
      }
    }
  },
  productSearchKeydown: function(e) {
    var pac_items= document.getElementById('product-list');

    if(pac_items) {
      pac_items = pac_items.getElementsByTagName('div');
    }

    if(e.keyCode == 40) {
      LOCATOR.product_search_index++;
      LOCATOR.productSearchSetActive(pac_items);
    } else if(e.keyCode == 38) {
      LOCATOR.product_search_index--;
      LOCATOR.productSearchSetActive(pac_items);
    } else if (e.keyCode == 13) {
      if(LOCATOR.product_search_index > -1) {
        if(pac_items) {
          e.preventDefault();
          pac_items[LOCATOR.product_search_index].click();
        }
      }
    }
  },
  productSearchCloseList: function(el) {
    var product_list = document.getElementById('product-list');

    if(product_list) {
      if(el != product_list && el != LOCATOR.product_search) {
        product_list.parentNode.removeChild(product_list);
      }
    }
  },
  productSearchSetActive: function(pac_items) {
    if(!pac_items) {
      return false;
    }

    LOCATOR.productSearchRemoveActive(pac_items);
    if(LOCATOR.product_search_index >= pac_items.length) {
      LOCATOR.product_search_index = 0;
    }
    if(LOCATOR.product_search_index < 0) {
      LOCATOR.product_search_index = (pac_items.length - 1);
    }
    pac_items[LOCATOR.product_search_index].classList.add('pac-item-selected');
  },
  productSearchRemoveActive: function(pac_items) {
    var i;

    for(i = 0; i < pac_items.length; i++) {
      pac_items[i].classList.remove('pac-item-selected');
    }
  },
  productChanged: function() {
    if(LOCATOR.product === 'paint') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_paint)))+"')" });
    } else if(LOCATOR.product === 'ontario-lights') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_lights)))+"')" });
    } else if(LOCATOR.product === 'lights') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_lights)))+"')" });
    } else if(LOCATOR.product === 'commercial-lights') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_commercial_lights)))+"')" });
    } else if(LOCATOR.product === 'hhw') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_hhw)))+"')" });
    } else if(LOCATOR.product === 'hsp') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_hhw)))+"')" });
    } else if(LOCATOR.product === 'alarms') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_alarm)))+"')" });
    } else if(LOCATOR.product === 'non-refillable-pressurized-cylinders') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_non_refillable_pressurized_cylinders)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(LOCATOR.product === 'refillable-propane-cylinders') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_refillable_propane_cylinders)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(LOCATOR.product === 'residential-fixtures') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_residential_fixtures)))+"')" });
    } else if(LOCATOR.product === 'commercial-fixtures') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_commercial_fixtures)))+"')" });
    } else if(LOCATOR.product === 'ballasts') {
      jQuery('#product-search').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_ballasts)))+"')" });
    }

    LOCATOR.mapSetCenter();
    LOCATOR.mapFilterCollectionSites();
  },
  updateProducts: function() {
    if(province_products[LOCATOR.province]) {
      jQuery('#product-select option[value!=""]').attr('disabled', true);

      for(var $i=0; $i<province_products[LOCATOR.province].length; $i++) {
        jQuery('#product-select option[value="'+province_products[LOCATOR.province][$i]+'"]').attr('disabled', false);
      }

      if(jQuery('#product-select option:selected').prop('disabled') === true) {
        this.product_select.value = '';
        this.productSelectChanged(this.product_select);
      }
    }
  },

  initProductSelect: function() {
    LOCATOR.setProduct(this.product_select.value);
    this.product_select.addEventListener('change', this.productSelectChanged);
  },
  productSelectChanged: function() {
    LOCATOR.setProduct(this.value);
    LOCATOR.mapSetCenter();
    LOCATOR.mapFilterCollectionSites();
  },
  setProduct: function(product) {
    LOCATOR.product = (product !== '') ? product : false;

    if(product === 'paint' || product === 'paint-cans') {
      jQuery('#product-select').css({backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_paint)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'paint-aerosol') {
      jQuery('#product-select').css({backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_paint_aerosol)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'ontario-lights') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_lights)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'lights') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_lights)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'commercial-lights') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_commercial_lights)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'hhw') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_hhw)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'hsp') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_hhw)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'non-refillable-pressurized-cylinders') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_non_refillable_pressurized_cylinders)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'refillable-propane-cylinders') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_refillable_propane_cylinders)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'alarms') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_alarms)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'paintshare') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_paintshare)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'residential-fixtures') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_residential_fixtures)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'commercial-fixtures') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_commercial_fixtures)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'ballasts') {
      jQuery('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_ballasts)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else {
      jQuery('#product-select').css({ backgroundImage:"url(''), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    }
  },

  initForm: function() {
    this.checkParams();
    window.onhashchange = this.checkParams();

    jQuery('.collection-sites-filter form').submit(function(e) {
      e.preventDefault();

      jQuery('.collection-sites-filter.open').removeClass('open');
      window.location = jQuery(this).attr('action')+'#'+jQuery(this).serialize();
    });
  },
  checkParams: function() {
    var $params = this.getHashParameters();
    if($params.location) {
      this.location_search_input.value = decodeURIComponent($params.location.replace(/\+/g, '%20'));
    }
    if($params.product) {
      this.product_select.value = decodeURIComponent($params.product.replace(/\+/g, '%20'));
    }
  },

  initGeocoder: function() {
    this.geocoder = new google.maps.Geocoder();
    this.geolocate();
  },
  geolocate: function() {
    if(this.location_search_input.value !== '') {
      this.geocoder.geocode({ address:this.location_search_input.value }, function(results, status) {
        if(status == google.maps.GeocoderStatus.OK) {
          if(results[0]) {
            LOCATOR.setGeolocation(results[0].geometry.location.lat(), results[0].geometry.location.lng());
            LOCATOR.setProvince(LOCATOR.getProvinceFromResults(results[0]));
          } else {
            LOCATOR.handleError('geolocation error');
          }
        } else {
          LOCATOR.handleError('geolocation error');
        }
      });
    } else if(navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        LOCATOR.setGeolocation(position.coords.latitude, position.coords.longitude);
        LOCATOR.setProvince();
      }, function() {
        // fallback to ip lookup
        jQuery.ajax('https://api.ipdata.co/?api-key=1955cfc26f85e2101dc961e35a949ef1d7fa541be59d2719597b7d39').then(
          function success(response) {
            LOCATOR.setGeolocation(response.latitude, response.longitude);
            LOCATOR.setProvince(response.region_code.toLowerCase());
          },
          function fail(data, status) { // set default
            LOCATOR.setGeolocation(62.24, -96.28);
            LOCATOR.setProvince(false);
          }
        );
      });
    } else {
      // fallback to ip lookup
      jQuery.ajax('https://api.ipdata.co/?api-key=1955cfc26f85e2101dc961e35a949ef1d7fa541be59d2719597b7d39').then(
        function success(response) {
          LOCATOR.setGeolocation(response.latitude, response.longitude);
          LOCATOR.setProvince(response.region_code.toLowerCase());
        },
        function fail(data, status) { // set default
          LOCATOR.setGeolocation(62.24, -96.28);
          LOCATOR.setProvince(false);
        }
      );
    }
  },
  setGeolocation: function(lat, lng) {
    LOCATOR.geolocation = {
      lat: lat,
      lng: lng
    };

    if(LOCATOR.origin_marker) {
      LOCATOR.origin_marker.setMap(null);
    }
    LOCATOR.origin_marker = new google.maps.Marker({
      position: LOCATOR.geolocation,
      map: LOCATOR.map,
      icon: {
        size: new google.maps.Size(48, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        url: LOCATOR.origin_icon_url,
        scaledSize: new google.maps.Size(48, 48),
      },
      optimized: false,
    })

    LOCATOR.mapSetCenter();
  },
  setProvince: function(province) {
    if(province) {
      LOCATOR.province = province;
      LOCATOR.updateProducts();
      LOCATOR.mapFilterCollectionSites();
    } else {
      var latlng = LOCATOR.geolocation.lat + "," + LOCATOR.geolocation.lng
          apiurl = 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCfR1q47DgBizD6o9y37QAS9oIZ0R0QYXM&latlng=' + latlng;

      jQuery.getJSON(apiurl, function(data) {
        if(data.status == 'OK') {
          if(data.results[0]) {
            LOCATOR.province = LOCATOR.getProvinceFromResults(data.results[0]);
            LOCATOR.updateProducts();
            LOCATOR.mapFilterCollectionSites();
          } else {
            LOCATOR.province = false;
            LOCATOR.updateProducts();
            LOCATOR.mapFilterCollectionSites();
            LOCATOR.handleError('province error');
          }
        } else {
          LOCATOR.province = false;
          LOCATOR.updateProducts();
          LOCATOR.mapFilterCollectionSites();
          LOCATOR.handleError('province error');
        }
      });
    }
  },
  getProvinceFromResults: function(results) {
    for(var i = 0; i < results.address_components.length; i++) {
      if(results.address_components[i].types[0] === 'administrative_area_level_1') {
        return results.address_components[i].short_name.toLowerCase();
      }
    }
    return false;
  },

  windowResize: function() {
    this.window_width = window.innerWidth;
    this.window_height = window.innerHeight;

    if(this.window_width <= 640) {
      this.is_mobile = true;
    } else if(this.window_width <= 1024) {
      this.is_tablet = true;
      this.is_mobile = false;
    } else {
      this.is_tablet = false;
      this.is_mobile = false;
    }
  },
  windowScroll: function() {
    if(!LOCATOR.is_tablet && !LOCATOR.is_mobile) {
      var scroll_top = jQuery(window).scrollTop(),
          height = LOCATOR.window_height - 306 + scroll_top;

      if(LOCATOR.window_width <= 1280) {
        height = jQuery(window).height() - 282 + scroll_top;
      }

      if(jQuery('.notification-bar').length>0) {
        var notification_bar_height = jQuery('.notification-bar').outerHeight();
        height = height - notification_bar_height;
      }

      jQuery('#map').css({ height:height });
    } else {
      jQuery('#map').css({ height:'100%' });
    }
  },
  distHaversine: function(p1, p2) {
    function rad(x) { return x*Math.PI/180; }

    var R = 6371; // earth's mean radius in km
    var dLat  = rad(p2.lat - p1.lat);
    var dLong = rad(p2.lng - p1.lng);
    var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    var d = R * c;
    return d.toFixed(2);
  },
  handleError: function(error) {
    if(error == 'no results') {
      if(LOCATOR.province === 'qc') {
        jQuery('#results').html('<div class="no-results"><h3>'+t_no_results_copy_qc+'</h3></div>');
      } else {
        jQuery('#results').html('<div class="no-results"><h3>'+t_no_results_header+'</h3><p>'+t_no_results_copy+'</p></div>');
      }
    }
  },
  getHashParameters: function() {
    var vars = {};
    var parts = window.location.hash.replace(/[#&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
  }
};
